import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
const options = {
  name: 'error-page',
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    minHeight: '60vh',
    flex: '1 0 auto',
  },
  code: {
    fontSize: '4rem',
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.info.main,
    [theme.breakpoints.up('md')]: {
      fontSize: '7.5rem',
    },
  },
  title: {
    color: theme.palette.info.main,
    marginBottom: theme.spacing(2),
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      marginBottom: theme.spacing(4),
    },
  },
  text: {
    maxWidth: 760,
    marginBottom: theme.spacing(3),
    textAlign: 'center',
    lineHeight: 2,
  },
  btn: {
    padding: theme.spacing(1, 4),
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(1.8, 6),
    },
  },
  link: {
    fontSize: 14,
    fontWeight: theme.typography.fontWeightLight,
    color: theme.palette.grey[600],
    [theme.breakpoints.up('md')]: {
      fontSize: 16,
    },
  },
  actions: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  options,
}));

export default useStyles;
